import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";

import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

export interface TimeStampProps {
  createdAt: string;
}

export const TimeStamp = ({ createdAt }: TimeStampProps) => (
  <Typography.LabelXs color="text-default">
    {dateStringToTimeAgo(createdAt)}
  </Typography.LabelXs>
);
